/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Erreur rencontrée lors du traitement d\'un objet dans un lot
 */
export const batchErrorSchema = z.object({
      "index": z.number().int().describe("Index de l'objet dans la liste envoyée").optional(),
  "id": z.string().describe("ID de l'objet en erreur, si fourni").optional(),
  "name": z.string().describe("Nom de l'objet en erreur, si fourni").optional(),
  "message": z.string().describe("Message détaillé de l'erreur").optional(),
  "status": z.number().int().describe("Code de statut HTTP associé à l'erreur").optional()
      }).describe("Erreur rencontrée lors du traitement d'un objet dans un lot")